import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, ModalBody, ModalFooter, Table } from "reactstrap";
import { useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";

const BlockedAdmins = () => {
  const [blockedAdmins, setBlockedAdmins] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const token = useSelector((state) => state.auth.userToken);

  useEffect(() => {
    const fetchBlockedAdmins = async () => {
      try {
        const response = await apiRequest('get', `${process.env.REACT_APP_API_BASE_URL}/admin/blocked-subadmins`, {}, token);
        setBlockedAdmins(response.data.blockedSubAdmins);
      } catch (error) {
        console.error("Error fetching blocked admins:", error);
      }
    };

    fetchBlockedAdmins();
  }, [token]);

  const handleUnblockAdmin = async () => {
    try {
      await apiRequest('patch', `${process.env.REACT_APP_API_BASE_URL}/admin/unblock-sub-admin/${selectedUser._id}`, {}, token);

      // Update the blocked admins list after unblocking
      setBlockedAdmins(blockedAdmins.filter((admin) => admin._id !== selectedUser._id));
      setModalOpen(false);
    } catch (error) {
      console.error("Error unblocking admin:", error);
    }
  };

  const handleUnblockModal = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  return (
    <div className="container-fluid">
      <h2>Blocked Admins</h2>
      <Table striped>
        <thead>
          <tr>
            <th>Username</th>
            <th>Email</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {blockedAdmins.map((admin) => (
            <tr key={admin._id}>
              <td>{admin.userName}</td>
              <td>{admin.email}</td>
              <td>
                <Button color="success" onClick={() => handleUnblockModal(admin)}>
                  Unblock
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalBody>
          Are you sure you want to unblock this admin?
        </ModalBody>
        <ModalFooter>
          <Button color="black" onClick={() => setModalOpen(!modalOpen)}>
            Cancel
          </Button>
          <Button color="success" onClick={handleUnblockAdmin}>
            Unblock
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default BlockedAdmins;
